// extracted by mini-css-extract-plugin
export default {"component":"ResponsiveImage__component-yEOb","loaded":"ResponsiveImage__loaded-EEDy"};